function checkForWordInURL(referrer: string, word: string) {
  return new RegExp(word, 'g').test(referrer)
}

export default checkForWordInURL
